import { render, staticRenderFns } from "./jala-pond.vue?vue&type=template&id=0fcc619e&"
import script from "./jala-pond.vue?vue&type=script&lang=js&"
export * from "./jala-pond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports